"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFileUtils = require("react-file-utils");
var _streamChatReact = require("stream-chat-react");
require("./TeamMessageInput.less");
var _TeamTypingIndicator = require("../TeamTypingIndicator/TeamTypingIndicator");
var _components = require("./components");
var _sendArrow = _interopRequireDefault(require("../../../../../images/send-arrow.svg"));
var _CustomTriggerProvider = require("../../CustomTriggerProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var TeamMessageInput = function TeamMessageInput(props) {
  var pinsOpen = props.pinsOpen;
  var _useChannelStateConte = (0, _streamChatReact.useChannelStateContext)(),
    acceptedFiles = _useChannelStateConte.acceptedFiles,
    maxNumberOfFiles = _useChannelStateConte.maxNumberOfFiles,
    multipleUploads = _useChannelStateConte.multipleUploads,
    thread = _useChannelStateConte.thread;

  // const [boldState, setBoldState] = useState(false);
  // const [italicState, setItalicState] = useState(false);

  // const resetIconState = () => {
  //   setBoldState(false);
  //   setItalicState(false);
  // };

  var messageInput = (0, _streamChatReact.useMessageInputContext)();
  var onChange = (0, _react.useCallback)(function (e) {
    // const { value } = e.target;
    // const deletePressed = e.nativeEvent?.inputType === 'deleteContentBackward';

    // if (boldState) {
    //   if (deletePressed) {
    //     e.target.value = `${value.slice(0, value.length - 2)}**`;
    //   } else {
    //     e.target.value = `**${value.replace(/\**/g, '')}**`;
    //   }
    // } else if (italicState) {
    //   if (deletePressed) {
    //     e.target.value = `${value.slice(0, value.length - 1)}*`;
    //   } else {
    //     e.target.value = `*${value.replace(/\*/g, '')}*`;
    //   }
    // }

    messageInput.handleChange(e);
  }, [messageInput] //boldState, italicState,
  );
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__wrapper ".concat((!!thread || pinsOpen) && 'thread-open')
  }, /*#__PURE__*/_react.default.createElement(_TeamTypingIndicator.TeamTypingIndicator, {
    type: "input"
  }), /*#__PURE__*/_react.default.createElement(_CustomTriggerProvider.CustomTriggerProvider, null, /*#__PURE__*/_react.default.createElement(_reactFileUtils.ImageDropzone, {
    accept: acceptedFiles,
    handleFiles: messageInput.uploadNewFiles,
    multiple: multipleUploads,
    disabled: maxNumberOfFiles !== undefined && messageInput.numberOfUploads >= maxNumberOfFiles
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__input"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__top"
  }, /*#__PURE__*/_react.default.createElement(_streamChatReact.UploadsPreview, null), /*#__PURE__*/_react.default.createElement(_streamChatReact.ChatAutoComplete, {
    placeholder: "Write a message",
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__button-height-control"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__button",
    role: "button",
    "aria-roledescription": "button",
    onClick: messageInput.handleSubmit,
    style: {
      backgroundImage: "url(".concat(_sendArrow.default, ")")
    }
  }, /*#__PURE__*/_react.default.createElement(_components.SendButton, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-message-input__icons"
  }, /*#__PURE__*/_react.default.createElement(_components.SmileyFace, {
    openEmojiPicker: messageInput.openEmojiPicker
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-divider"
  }), /*#__PURE__*/_react.default.createElement(_reactFileUtils.FileUploadButton, {
    accepts: acceptedFiles,
    disabled: maxNumberOfFiles !== undefined && messageInput.numberOfUploads >= maxNumberOfFiles,
    handleFiles: messageInput.uploadNewFiles,
    multiple: multipleUploads
  })))))), /*#__PURE__*/_react.default.createElement(_streamChatReact.EmojiPicker, {
    small: true
  }));
};
var _default = TeamMessageInput;
exports.default = _default;